import config from 'config'

const storeApi = `${config.apiHost}/oem-profile`

export default {
    // 分组
    groups: {
        url: `${storeApi}/api/stores/groups/tree`,
        type: 'GET',
    },
    // 所有门店
    allStores: {
        url: `${storeApi}/api/stores/all`,
        type: 'GET',
    },
    stores: {
        url: `${storeApi}/api/stores`,
        type: 'GET',
    },
    getGroupList: {
        url: `${storeApi}/api/stores/poly/list`,
        type: 'GET',
    },
    saveGroup: {
        url: `${storeApi}/api/stores/poly/add`,
        type: 'POST',
    },

    editGroup: {
        url: `${storeApi}/api/stores/poly/{id}`,
        type: 'PUT',
    },
    delGroup: {
        url: `${storeApi}/api/stores/poly/delete/{id}`,
        type: 'DELETE',
    },
    downloadTemplate: {
        url: `${storeApi}/api/stores/poly/template.xlsx`,
        type: 'POST',
    }
}
